import Vue from 'vue';
import store from './../../store';
import organizationMemberTransformer from './../../transformers/organizationMember';

const success = ({ data }, resolve) => {
  const organizationMembers = organizationMemberTransformer.fetchCollection(data);
  store.dispatch('fetchAllOrganizationMembers', organizationMembers);
  resolve(organizationMembers);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/organization_members')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationMember/all.js